import {Box, IconButton} from "@mui/material";
import '../../styles/chat.scss'
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';

export default function Handle () {
    return <Box style={{display: 'flex'}}>
        <div style={{background: 'var(--c-bg)', borderRadius: 5}}>
            <IconButton aria-label="delete" size="small">
                <FullscreenOutlinedIcon fontSize="inherit"/>
            </IconButton>
        </div>
        <div style={{background: 'var(--c-bg)', marginLeft: 6, borderRadius: 5}}>
            <IconButton aria-label="delete" size="small">
                <AutorenewOutlinedIcon fontSize="inherit"/>
            </IconButton>
        </div>
        <div style={{background: 'var(--c-bg)', marginLeft: 6, borderRadius: 5}}>
            <IconButton aria-label="delete" size="small">
                <ControlPointOutlinedIcon fontSize="inherit"/>
            </IconButton>
        </div>
        <div style={{background: 'var(--c-bg)', marginLeft: 6, borderRadius: 5}}>
            <IconButton aria-label="delete" size="small">
                <DeleteOutlineOutlinedIcon fontSize="inherit"/>
            </IconButton>
        </div>
    </Box>
}